/**
 * Cloudflare Turnstile on guest forms (server side: src/Turnstile.php). Usually invisible: Cloudflare shows a
 * box only when it wants the visitor to tick it. Off while Admin > Voucha Theme has no site key.
 *
 * Other extensions use the global component, so they don't depend on this theme being installed:
 *   window.VouchaTurnstile ? m(window.VouchaTurnstile, { onToken: (t) => (this.turnstile = t), bind: (w) => (this.cf = w) }) : null
 * and send the token as "turnstile". w.reset() gets a fresh token after a failed send (each token works once).
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
let loading = null;
function loadScript() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = () => resolve(window.turnstile);
      s.onerror = () => {
        loading = null;
        reject(new Error('Turnstile did not load'));
      };
      document.head.appendChild(s);
    });
  }
  return loading;
}
export const turnstileKey = () => app.forum && app.forum.attribute('vouchaTurnstileKey') || '';
export class VouchaTurnstile {
  oncreate(vnode) {
    this.attrs = vnode.attrs;
    const key = turnstileKey();
    const give = t => this.attrs.onToken && this.attrs.onToken(t);
    if (this.attrs.bind) this.attrs.bind({
      reset: () => this.reset()
    });
    if (!key) return;
    loadScript().then(ts => {
      if (!vnode.dom.isConnected || !ts) return;
      this.ts = ts;
      this.id = ts.render(vnode.dom, {
        sitekey: key,
        // match the page (Flarum's colour scheme), not the device's
        theme: /dark/.test(document.documentElement.getAttribute('data-theme') || '') ? 'dark' : 'light',
        appearance: 'interaction-only',
        size: 'flexible',
        action: this.attrs.action || 'form',
        callback: t => give(t),
        'expired-callback': () => give(''),
        'error-callback': () => give('')
      });
    })
    // Cloudflare blocked or down: the form still sends, and the server decides
    .catch(() => {});
  }
  onupdate(vnode) {
    this.attrs = vnode.attrs;
  }
  reset() {
    if (this.attrs && this.attrs.onToken) this.attrs.onToken('');
    try {
      if (this.ts && this.id !== undefined) this.ts.reset(this.id);
    } catch (e) {}
  }
  onremove() {
    try {
      if (this.ts && this.id !== undefined) this.ts.remove(this.id);
    } catch (e) {}
  }
  view() {
    return m('div.VouchaTurnstile');
  }
}
export default function vouchaTurnstile() {
  window.VouchaTurnstile = VouchaTurnstile;

  // Sign up: the check sits above the button; its token goes with the form as "vouchaTurnstile".
  // (The sign-up modal loads on demand in Flarum 2, so it's hooked by its path.)
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    if (!turnstileKey() || this.attrs.token) return;
    items.add('vouchaTurnstile', m(VouchaTurnstile, {
      action: 'signup',
      onToken: t => this.vouchaTurnstile = t,
      bind: w => this.vouchaTurnstileWidget = w
    }), -5);
  });
  extend('flarum/forum/components/SignUpModal', 'submitData', function (data) {
    if (data && this.vouchaTurnstile) data.vouchaTurnstile = this.vouchaTurnstile;
  });
  // a refused sign-up (name taken, check failed) used up the token: get a new one
  extend('flarum/forum/components/SignUpModal', 'onerror', function () {
    if (this.vouchaTurnstileWidget) this.vouchaTurnstileWidget.reset();
  });
}